import React, { useContext } from 'react'
import { Box } from '@material-ui/core'
import HeadControlPanel from 'components/HeadControlPanel'

import { SearchInput } from 'components/base/SearchInput/SearchInput'
import RawButton from 'components/base/RawButton'

import { ReactComponent as FilterIcon } from 'assets/media/ic_filter.svg'
import { ReactComponent as MenuIcon } from 'assets/media/ic_menu.svg'
import { TranslationContext } from 'contexts/TranslationContext'
import { selectElementDisplayType } from 'selectors/useInterface'
import { useSelector } from 'react-redux'
import { DISPLAY_TYPE } from 'config/constants/ui'
import { SOURCE_FILE_TYPES } from 'enums'

type MenuType = typeof SOURCE_FILE_TYPES [ keyof typeof SOURCE_FILE_TYPES ]

type Props = {
  caption: string,
  type: MenuType
}

const noop = () => {}

const showHeader = ![ 'vrspot', 'public', 'desktop', 'itochu' ].includes(__APP_PROFILE__)

function DummyHeader({ caption, type }: Props) {
  const { t } = useContext(TranslationContext)
  const { sourceList: sourceListDisplayType } = useSelector(selectElementDisplayType)
  const excludeFilters = [ SOURCE_FILE_TYPES.TRANSITIONS, SOURCE_FILE_TYPES.TEXT ] as unknown as MenuType
  return (
    showHeader
      ? (
        <HeadControlPanel caption={caption} fullWidth>
          <Box
            display="flex"
            gridRowGap={2}
            marginBottom={sourceListDisplayType === DISPLAY_TYPE.MIN_WIDTH ? 1 : 0}
            justifyContent="flex-end"
          >
            {__CFG__.SOURCE_FILES_MANAGEMENT.FILTER && !excludeFilters.includes(type) && (
            <div className="head-control__btn" title={t('DUMMY_HEADER_BTN_FILTERS_TOOLTIP')}>
              <RawButton ariaLabel={t('DUMMY_HEADER_BTN_FILTERS_TOOLTIP')}>
                <FilterIcon />
              </RawButton>
            </div>
            )}

            {__CFG__.SOURCE_FILES_MANAGEMENT.VIEW_OPTIONS
            && !excludeFilters.includes(type)
            && (
            <div className="head-control__btn" title={t('DUMMY_HEADER_BTN_VIEW_SETTINGS_TOOLTIP')}>
              <RawButton ariaLabel={t('DUMMY_HEADER_BTN_VIEW_SETTINGS_TOOLTIP')}>
                <MenuIcon />
              </RawButton>
            </div>
            )}
          </Box>
          {__CFG__.SOURCE_FILES_MANAGEMENT.SEARCH && !excludeFilters.includes(type)
          && <SearchInput onSearch={noop} />}
        </HeadControlPanel>
      )
      : <HeadControlPanel caption={caption} fullWidth />
  )
}

export { DummyHeader }
